export default __webpack_public_path__ + "static/media/logo-bank-mandiri.e4ebe5db.png";